import { tracked } from '@glimmer/tracking';

export default class IsReady {
  @tracked isReady = true;

  markAsReady() {
    this.isReady = true;
  }

  markAsNotReady() {
    this.isReady = false;
  }
}
